import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=4bc2e3a0&scoped=true"
import script from "./layout-header.vue?vue&type=script&lang=js"
export * from "./layout-header.vue?vue&type=script&lang=js"
import style0 from "./layout-header.vue?vue&type=style&index=0&id=4bc2e3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc2e3a0",
  null
  
)

export default component.exports